import { Component , OnInit } from '@angular/core';
import * as $ from 'jquery';


@Component({
  selector: 'app-blog-detail',
  templateUrl: './blogdetail.component.html',
})
export class BlogDetailComponent implements OnInit {
  ngOnInit() {
  }
}
